import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-section" }

import SectionSidebar from '@/components/SectionSidebar.vue'
import type { SidebarMenuItem } from '@/components/SectionSidebar.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'BudgetLayout',
  setup(__props) {

const menuItems: SidebarMenuItem[] = [
  {
    to: '/front/budget',
    icon: '/public/icons/icon-budget.svg',
    label: 'Budget',
    exact: true,
    initialSidebarOpen: true
  },
  {
    to: '/front/budget/previsions',
    icon: '/public/icons/icon-budget-prevision.svg',
    label: 'Prévisions',
    initialSidebarOpen: true
  },
  {
    to: '/front/budget/categories',
    icon: '/public/icons/icon-plan.svg',
    label: 'Catégories',
    initialSidebarOpen: true
  }
]

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SectionSidebar, { "menu-items": menuItems }),
    _createElementVNode("section", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "page-space-25" }, null, -1)),
      _createVNode(_component_router_view)
    ])
  ], 64))
}
}

})